import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  vendors: [],
  products: [],
  currentPageOnList: 1
}

export const getters = {
  currentPage: state => state.currentPageOnList,
}

export const mutations = {
  [types.UPDATE_PAGE] (state, { pageNum }) {
    state.currentPageOnList = pageNum
  }
}

// actions
export const actions = {
  setPageNum ({ commit, dispatch }, payload) {
    commit(types.UPDATE_PAGE, payload)
  }
}
